import React, { createContext, useContext, useState } from "react";
import CommonLoader from "./CommonLoader";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState({
    isLoading: false,
    text: "Loading, please wait...",
  });

  const showLoader = (text = "Loading, please wait...") => {
    setLoader({ isLoading: true, text });
  };

  const hideLoader = () => {
    setLoader({ isLoading: false, text: "" });
  };

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      <CommonLoader isLoading={loader.isLoading} text={loader.text} />
      {children}
    </LoaderContext.Provider>
  );
};

export const useCommonLoader = () => useContext(LoaderContext);